module.exports={
	"Form": "TestCreateManifest",
	"Scope": "Test-Create",
	"Descriptors":
	{
		"TestDetails.Name":
		{
			"Name": "Name",
			"Hash": "Test-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Test-Create-Identity",
				"Group": "Test-Create-Identity"
			}
		},
		"TestDetails.Description":
		{
			"Name": "Description",
			"Hash": "Test-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Test-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Test-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Active":
		{
			"Name": "Active",
			"Hash": "Test-Create-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Standalone":
		{
			"Name": "Standalone",
			"Hash": "Test-Create-Standalone",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Injectable":
		{
			"Name": "Injectable",
			"Hash": "Test-Create-Injectable",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Collection":
		{
			"Name": "Collection",
			"Hash": "Test-Create-Collection",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.SmallQuantityExempt":
		{
			"Name": "Small Quantity Exempt",
			"Hash": "Test-Create-SmallQuantityExempt",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Test-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Test-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Test-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Test-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
